import { checkHttpStatusAuthCheck } from '../../../../../actions/utilAction';
import {
    actionCreator,
    checkHttpStatus, 
    jsonApiHeader, 
    showErrorMessage, 
    showSuccessMessage, 
    manageAppointmentsActionTypes, 
    createSearchUrlForCustomAPI,
    GET_PATIENT_APPOINTMENT_LIST_FOR_AGENCY, 
    POST_EMCOUNTER_WITH_SIGNATURE_AND_GENERATE_CLAIM_FOR_AGENCY, 
    GET_MASTERDATABYNAME,
    CANCEL_APPOINTMENT_API,
} from '../constants/ApiConstants';

export const getAppointmentList = (searchObj) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(manageAppointmentsActionTypes.get_patient_appointment_list.REQUEST));
        let query_params = createSearchUrlForCustomAPI(searchObj);
        fetch(`${GET_PATIENT_APPOINTMENT_LIST_FOR_AGENCY}${query_params}`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(manageAppointmentsActionTypes.get_patient_appointment_list.SUCCESS, response));
                } else {
                    dispatch(actionCreator(manageAppointmentsActionTypes.get_patient_appointment_list.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_patient_appointment_list', error);
            });
    };
};

export const saveEncounterWithSignature = (formProps) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(manageAppointmentsActionTypes.save_encounter_with_signature.REQUEST));
        fetch(`${POST_EMCOUNTER_WITH_SIGNATURE_AND_GENERATE_CLAIM_FOR_AGENCY}`, {
            method: 'POST',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
            body: JSON.stringify(formProps),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    showSuccessMessage(response.message);
                    dispatch(actionCreator(manageAppointmentsActionTypes.save_encounter_with_signature.SUCCESS, response));
                } else {
                    showErrorMessage(response.message);
                    dispatch(actionCreator(manageAppointmentsActionTypes.save_encounter_with_signature.SUCCESS, null));
                }
            })
            .catch(function (error) {
                console.log('error save_encounter_with_signature', error);
            });
    };
};


export const getMasterData = (masterData) => {
    return (dispatch, getState) => {
      dispatch(actionCreator(manageAppointmentsActionTypes.get_masterdata.REQUEST));
      fetch(`${GET_MASTERDATABYNAME}`, {
        method: 'post',
        body: JSON.stringify(masterData),
        headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
        .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
        .then(function(response) {
          // console.log('Master Data response: ', response);
          dispatch(actionCreator(manageAppointmentsActionTypes.get_masterdata.SUCCESS, response));
        })
        .catch(function(error) {
          console.log('error getMasterData ..', error);
        });
    };
  };


  export const cancelAppointments = (formData) => {
    // let query_params = createSearchUrl(searchObj);
    // console.log(`${GET_APPOINTMENT_DATA_API}?appointmentId=${appointment_id}`);
    let postData = JSON.stringify(formData);
    return (dispatch, getState) => {
      dispatch(actionCreator(manageAppointmentsActionTypes.cancel_appointment.REQUEST));
      fetch(`${CANCEL_APPOINTMENT_API}`, {
        method: 'post',
        body: postData,
        headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
        .then(checkHttpStatus)
        .then(function(response) {
          // console.log('response: ', response);
          showSuccessMessage(response.message);
          dispatch(actionCreator(manageAppointmentsActionTypes.cancel_appointment.SUCCESS, response));
        })
        .catch(function(error) {
          console.log('cancel appointment error', error);
        });
    };
  };


// WEBPACK FOOTER //
// ./src/modules/ManageAppointments/components/appointments/actions/manageAppointmentAction.js